// 用户中心
export default {
    path: "/user",
    name: "user",
    component: () => import("../views/userCenter/index.vue"),
    children: [
        {
            path: "/user/info",
            component: () => import("../views/userCenter/info.vue"),
        },
        {
            path: "/user/gainManage",
            component: () => import("../views/userCenter/gainManage.vue"),
        },
        {
            path: "/user/examine",
            component: () => import("../views/userCenter/examine.vue"),
        },
        {
            path: "/user/addGainForeign",
            component: () => import("../views/userCenter/articleMine/addGainForeign.vue"),
        },
        {
            path: "/user/addGainEnglishForeign",
            component: () => import("../views/userCenter/articleMine/addGainEnglishForeign.vue"),
        },
        {
            path: "/user/addGainDegree",
            component: () => import("../views/userCenter/articleMine/addGainDegree.vue"),
        },
        {
            path: "/user/addGainMeting",
            component: () => import("../views/userCenter/articleMine/addGainMeting.vue"),
        },
        {
            path: "/user/addGainVideo",
            component: () => import("../views/userCenter/articleMine/addGainVideo.vue"),
        },
        {
            path: "/user/addGainCourseware",
            component: () => import("../views/userCenter/articleMine/addGainCourseware.vue"),
        },
        {
            path: "/user/editGainForeign",
            component: () => import("../views/userCenter/articleMine/editGainForeign.vue"),
        },
        {
            path: "/user/editGainEnglishForeign",
            component: () => import("../views/userCenter/articleMine/editGainEnglishForeign.vue"),
        },
        {
            path: "/user/editGainDegree",
            component: () => import("../views/userCenter/articleMine/editGainDegree.vue"),
        },
        {
            path: "/user/editGainMeting",
            component: () => import("../views/userCenter/articleMine/editGainMeting.vue"),
        },
        {
            path: "/user/editGainVideo",
            component: () => import("../views/userCenter/articleMine/editGainVideo.vue"),
        },
        {
            path: "/user/editGainCourseware",
            component: () => import("../views/userCenter/articleMine/editGainCourseware.vue"),
        },

        // 审核列表再次编辑
        {
            path: "/user/resetEditGainForeign",
            component: () => import("../views/userCenter/submitEdit/editGainForeign.vue"),
        },
        {
            path: "/user/resetEditGainDegree",
            component: () => import("../views/userCenter/submitEdit/editGainDegree.vue"),
        },
        {
            path: "/user/resetEditGainMeting",
            component: () => import("../views/userCenter/submitEdit/editGainMeting.vue"),
        },
        {
            path: "/user/resetEditGainVideo",
            component: () => import("../views/userCenter/submitEdit/editGainVideo.vue"),
        },
        {
            path: "/user/resetEditGainCourseware",
            component: () => import("../views/userCenter/submitEdit/editGainCourseware.vue"),
        },
        {
            path: "/user/resetEditGainLH",
            component: () => import("../views/userCenter/submitEdit/editGainLH.vue"),
        },
        // 成果列表再次编辑
        {
            path: "/user/editApGainForeign",
            component: () => import("../views/userCenter/apiMine/editGainForeign.vue"),
        },
        {
            path: "/user/editApGainDegree",
            component: () => import("../views/userCenter/apiMine/editGainDegree.vue"),
        },
        {
            path: "/user/editApGainMeting",
            component: () => import("../views/userCenter/apiMine/editGainMeting.vue"),
        },
        {
            path: "/user/editApGainVideo",
            component: () => import("../views/userCenter/apiMine/editGainVideo.vue"),
        },
        {
            path: "/user/editApGainCourseware",
            component: () => import("../views/userCenter/apiMine/editGainCourseware.vue"),
        },
        {
            path: "/user/editApGainLH",
            component: () => import("../views/userCenter/apiMine/editGainLH.vue"),
        },
        // 关注作者
        {
            path: "/user/careAuthor",
            component: () => import("../views/userCenter/careAuthor.vue"),
        },
        // 订单中心
        {
            path: "/user/orderListCenter",
            component: () => import("../views/userCenter/orderListCenter.vue"),
        },
        // 会员权益
        {
            path: "/user/equity",
            component: () => import("../views/userCenter/equity"),
        },
        // 我的收藏
        {
            path: "/user/collect",
            component: () => import("../views/userCenter/collect.vue"),
        },
        // 我的课程
        {
            path: "/user/subject",
            component: () => import("../views/userCenter/subject.vue"),
        },
        // 下载作品
        {
            path: "/user/loadLog",
            component: () => import("../views/userCenter/loadLog.vue"),
        },
        // 浏览记录
        {
            path: "/user/browLog",
            component: () => import("../views/userCenter/browLog.vue"),
        },
        // 教师信息
        {
            path: "/user/teacherInfo",
            component: () => import("../views/userCenter/teacherInfo.vue"),
        },
        {
            path: "/user",
            redirect: "/user/info",
        },
        // 我的教研活动报名投稿
        {
            path: "/user/activitySign",
            component: () => import("../views/userCenter/activitySign.vue"),
        },
        // 我的教研活动科研投稿
        {
            path: "/user/activityResearch",
            component: () => import("../views/userCenter/activityResearch.vue"),
        },
        // 投稿成果
        {
            path: "/user/fileGain",
            component: () => import("../views/userCenter/fileGain.vue"),
        },
        // 课题成果
        {
            path: "/user/topicGain",
            component: () => import("../views/userCenter/topicGain.vue"),
        },
        // 检测报告
        {
            path: "/user/reportLog",
            component: () => import("../views/userCenter/reportLog.vue"),
        },

        // // 投稿成果
        // {
        //   path: "/user/word",
        //   component: () => import("../views/userCenter/word.vue"),
        // },

    ],
}